"use client";
import LeftDrawer from "@/components/ui/drawer/LeftDrawer";
import Image from "next/image";
import React, { useState } from "react";
import { IoMenuOutline } from "react-icons/io5";

import logo_msu_white from "@/public/logo-msu-white.svg";
import getYear from "@/utils/getYear";
import config from "../../../package.json";
import { NavUser } from "./NavUser";

const SidebarButton = ({
  user,
  children,
}: {
  user: {
    groupId: string | null;
    isAdmin: boolean;
    username: string;
    email: string;
  };
  children?: React.ReactNode;
}) => {
  const [open, setOpen] = useState(false);

  return (
    <div>
      <button
        type="button"
        className="-m-2.5 p-2.5 text-gray-700 lg:hidden"
        onClick={() => setOpen(true)}
      >
        <span className="sr-only">Open sidebar</span>
        <IoMenuOutline className="h-auto w-6" />
      </button>
      <LeftDrawer
        open={open}
        setOpen={setOpen}
        title={
          <div className="flex h-16 w-full items-center justify-between border-b border-gray-800 px-4 ">
            <Image
              src={logo_msu_white}
              className="h-10 w-auto"
              alt="Movimiento Scout del Uruguay"
            />
            <span className="rounded-lg border-2 border-white px-8 py-2 text-2xl font-semibold text-white">
              {getYear()}
            </span>
          </div>
        }
      >
        <div className="inset-y-0 flex flex-col px-4">
          <nav>
            <NavUser user={user} />
            <h3 className="my-6 text-sm font-light text-gray-500">MÓDULOS</h3>
            {children}
          </nav>
          <div className="flex grow flex-col justify-end">
            <div className="my-4 flex w-full items-center justify-center gap-x-2 rounded-lg bg-gray-800 p-4">
              <Image
                src="/logo-sherpa.svg"
                className=""
                alt="Sherpa"
                height={15}
                width={70}
              />
              <span className="text-sm font-light text-gray-500">
                v{config.version}
              </span>
            </div>
          </div>
        </div>
      </LeftDrawer>
    </div>
  );
};

export default SidebarButton;
